import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import GlobalQuote from '~/components/molecules/Editorial/Global/GlobalQuote.vue';
import TrendInspiration from '~/components/molecules/Editorial/Trend/TrendInspiration.vue';
import { formatPrismicImage } from '~/helpers/image-helper';
import { EMPTY_PIXEL } from '~/const/images';
export default {
  name: 'GlobalQuotePortrait',
  components: {
    GlobalQuote: GlobalQuote,
    TrendInspiration: TrendInspiration
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12;

      return {
        background_color: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.background_color : _ref12 : _ref12) || '',
        background_image: formatPrismicImage((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? (_ref11 = _ref11.quote_background_image) != null ? _ref11.url : _ref11 : _ref11 : _ref11) || EMPTY_PIXEL,
        image: {
          small: formatPrismicImage((_ref10 = this.payload) != null ? (_ref10 = _ref10.primary) != null ? (_ref10 = _ref10.image) != null ? (_ref10 = _ref10.small) != null ? _ref10.url : _ref10 : _ref10 : _ref10 : _ref10) || EMPTY_PIXEL,
          medium: formatPrismicImage((_ref9 = this.payload) != null ? (_ref9 = _ref9.primary) != null ? (_ref9 = _ref9.image) != null ? (_ref9 = _ref9.medium) != null ? _ref9.url : _ref9 : _ref9 : _ref9 : _ref9) || EMPTY_PIXEL,
          large: formatPrismicImage((_ref8 = this.payload) != null ? (_ref8 = _ref8.primary) != null ? (_ref8 = _ref8.image) != null ? (_ref8 = _ref8.large) != null ? _ref8.url : _ref8 : _ref8 : _ref8 : _ref8) || EMPTY_PIXEL,
          alt: ((_ref7 = this.payload) != null ? (_ref7 = _ref7.primary) != null ? _ref7.alt : _ref7 : _ref7) || '',
          cinemagraph: {
            mp4: formatPrismicImage((_ref6 = this.payload) != null ? (_ref6 = _ref6.primary) != null ? (_ref6 = _ref6.video_mp4) != null ? _ref6.url : _ref6 : _ref6 : _ref6, [], '', 'video') || '',
            webm: formatPrismicImage((_ref5 = this.payload) != null ? (_ref5 = _ref5.primary) != null ? (_ref5 = _ref5.video_webm) != null ? _ref5.url : _ref5 : _ref5 : _ref5, [], '', 'video') || ''
          }
        },
        quote: {
          iconColor: ((_ref4 = this.payload) != null ? (_ref4 = _ref4.primary) != null ? _ref4.quote_icon_color : _ref4 : _ref4) || '',
          textColor: ((_ref3 = this.payload) != null ? (_ref3 = _ref3.primary) != null ? _ref3.quote_text_color : _ref3 : _ref3) || '',
          paragraph: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? _ref2.quote_text : _ref2 : _ref2) || '',
          signature: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.quote_signature : _ref : _ref) || ''
        }
      };
    }
  }
};